import { useQuery } from "@tanstack/react-query";
import { isEmpty, isString } from "lodash-es";
import type { TagIdentifiable } from "../model";
import { getTableRowById } from ":shared/database/get-table";
import { getTable, QUERY_KEYS, type Filters } from "./shared";

export function useRecords({
	filters = {},
	enabled = true,
	select,
}: {
	filters?: Filters;
	enabled?: boolean;
	select?: (data: TagIdentifiable[]) => TagIdentifiable[];
} = {}) {
	return useQuery({
		queryKey: QUERY_KEYS.records(filters),
		queryFn: async () => {
			if (isEmpty(filters)) {
				return getTable().toArray();
			}

			const idArr = isString(filters.id) ? [filters.id] : filters.id!;
			return getTable().where("id").anyOf(idArr).toArray();
		},
		enabled,
		select,
	});
}
export function getRecordById(id: TagIdentifiable["id"]) {
	return getTableRowById<TagIdentifiable, string>({ id, table: "tags" });
}
